<template>
  <div class="sdn">
    <v-header :inputName='Name'></v-header>
    <div class="manpin">
      <div class="miansdas">
        <!-- <img src="../../assets/img/topxiang.jpg"> -->
        <!-- <span>你好, {{userInfo.userName}}</span> -->
      </div>
      <v-massage ref="massage" style="width: 1280px;padding-top: 0;"></v-massage>
      <div class="main centen container">
        <div class="main_l">
          <jibenxinxi></jibenxinxi>
        </div>
        <!-- 在class为main_r里面写页面就行 -->
        <div class="main_r">
          <div class="mainr_top">
            <img src="../../assets/gerenzhongxin/geren16.png">
            我的选科
          </div>
          <div class="hb">
            <!-- 选科情况查询 -->
            <div class="modela" @click="xuankeqingkuang">
              <div class="model1 modelitem">
                <div class="model1-top">
                  <img src="../../../static/img/p6.png">
                  <span>选科情况查询</span>
                </div>
                <div class="model1-bottom">
                  <span>根据自己的选科查询可选择的专业分级和发展趋势</span>
                </div>
              </div>
            </div>
            <div class="modelb" @click="zhinengxuan">
              <div class="model2 modelitem" >
                <div class="model2-top">
                  <img src="../../../static/img/p7.png">
                  <span>智能选科</span>
                </div>
                <div class="model2-bottom">
                  <span>搜索并选择自己想填报的专业，然后根据选择的专业生成最佳选科方案</span>
                </div>
              </div>
            </div>
            <div class="modelc" @click="gengjucpxuan">
              <div class="model3 modelitem">
                <div class="model3-top">
                  <img src="../../../static/img/p8.png">
                  <span>根据测评选科</span>
                </div>
                <div class="model3-bottom">
                  <span>根据性格测评报告推荐的专业，获得适合自己的最佳选科信息</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <item7></item7>
    <zuoxuanfu1></zuoxuanfu1>
  </div>
</template>

<script>
  import vHeader from "../../components/vHeader.vue";
  import item7 from "../../components/item7.vue";
  import zuoxuanfu1 from '../../components/zuoxuanfu1.vue'
  import jibenxinxi from '../../components/jibenxinxi.vue'
  import vMassage from "../../components/vMassage.vue";
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      zuoxuanfu1,
      jibenxinxi,
      vMassage
    },
    data() {
      return {
        Name: null
      }
    },
    methods: {
      xuankeqingkuang() {
        this.$router.push('/xuankeqingkuangcaxunye')
      },
      // 智能选科
      zhinengxuan() {
        this.$router.push('/zhinengxuanke')
      },
      // 根据测评选科
      gengjucpxuan() {
        // 有俩状态跳转
        this.$router.push('/grzx_cepingjieguo') //状态1跳转
        // this.$router.push('/zhinengxuanke')  //状态2跳转

      },
    }


  }
</script>

<style scoped>
  .centen {
    width: 1280px;
    margin: 0 auto;
    margin-top: 20px;
  }
  .manpin {
    width: 100%;
    height: auto;
    padding-top: 70px;
    /* padding: 40px 0; */
    box-sizing: border-box;
    background: #EBE9E9;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
    background: #EBE9E9;
  }

  .main_l {
    /* background: rgba(251, 251, 251, 1); */
    width: 210px;
  }

  .main_r {
    width: 1190px;
    height: 580px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    margin-left: 20px;
    box-sizing: border-box;
  }

  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .modela {
    cursor: pointer;
  }

  .modelb {
    cursor: pointer;
  }

  .modelc {
    cursor: pointer;
  }

  .modelitem{
    padding: 15px 30px;
    box-sizing: border-box;
    width: 330px;
    height: 172px;
  }
  .xk-xia {
    margin-top: 40px;
  }

  .hb {
    display: flex;
    justify-content: center;
    padding: 70px 0;
  }

  .model3-bottom {
    margin: 10px;
    text-align: center;
  }

  .zhong {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .model3-bottom span {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    opacity: 1;
  }

  .model3-top span {
    text-align: center;
    line-height: 70px;
    font-size: 24px;
    font-weight: 500;
    color: #FFFFFF;
    opacity: 1;
  }

  .model3-top {
    justify-content: center;
    display: flex;
    color: white;

  }

  .model3 {

    background: url(../../../static/img/p5.png);
    background-size: 100% 100%;
  }


  .model2-bottom {
    margin: 10px;
    text-align: center;
  }

  .zhong {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .model2-bottom span {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    opacity: 1;
  }

  .model2-top span {
    text-align: center;
    line-height: 70px;
    font-size: 24px;
    font-weight: 500;
    color: #FFFFFF;
    opacity: 1;
  }

  .model2-top {
    justify-content: center;
    display: flex;
    color: white;

  }

  .model2 {
    background: url(../../../static/img/p4.png);
    background-size: 100% 100%;
  }







  .model1-bottom {
    margin: 10px;
    text-align: center;
  }

  .zhong {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .model1-bottom span {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    opacity: 1;
  }

  .model1-top span {
    text-align: center;
    line-height: 70px;
    font-size: 24px;
    font-weight: 500;
    color: #FFFFFF;
    opacity: 1;
  }

  .model1-top {
    justify-content: center;
    display: flex;
    color: white;

  }

  .model1 {
    background: url(../../../static/img/p3.png);
    background-size: 100% 100%;
  }

  .model {
    display: flex;
    justify-content: space-around;
  }

  .xia-tit span {
    font-size: 20px;
    font-weight: 500;
    margin-left: 6px;
    color: #29A7E1;
    opacity: 1;
  }

  .shu {
    background: url(../../../static/img/p2.png);
    width: 7px;
    height: 24px;
  }

  .xia-tit {
    height: 68px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
  }

  .heng {
    width: 30px;
    height: 4px;
    background: rgb(255, 255, 255);
    opacity: 1;
    border-radius: 4px;
  }

  .xk span {
    font-size: 36px;
    font-weight: 500;
    color: #FFFFFF;
    opacity: 1;
    margin: 0 20px;
  }

  .xk {
    background: url(../../../static/img/p1.png)no-repeat;
    background-size: 100% 100%;
    height: 150px;
    width: 100%;
    color: white;
    display: flex;
  }

  @media (max-width:750px) {
    .hb {
      display: block;
    }

    .model1 {
      width: 95%;
    }

    .model2 {
      width: 95%;
    }

    .model3 {
      width: 95%;
    }


    .xk {
      height: 75px;
    }

    .xk span {
      font-size: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/g_wdxuanke.vue